import { troubleshootItems } from "@/mocks/homeData";

export default function TroubleshootSection() {
  return (
    <section id="troubleshoot" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-tools-line" />
            访问排查
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-2xl md:text-4xl">
            常见访问异常，对号入座逐个解决
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            遇到问题先不要着急。下面列出最常见的几种情况与对应处理方式，多数都能在几分钟内解决。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {troubleshootItems.map((item) => (
            <div
              key={item.title}
              className="flex gap-4 rounded-lg bg-background-100 border border-background-200/70 p-5"
            >
              <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 text-xl">
                <i className={item.icon} />
              </span>
              <div>
                <h3 className="font-heading text-foreground-950 text-base md:text-lg">{item.title}</h3>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}